<template>
  <van-popup
    v-model="show"
    class="shop_car_container"
    :style="{ width: '80%'}"
    :close-on-click-overlay="false"
  >
    <div class="pop-wrap">
      <div class="pop-white__bg">
        <div class="num-title">请输入数量</div>
        <!-- <input type="tel" v-model="num" pattern="[0-9]*" onkeyup="value=value.replace(/[^\d]/g,'')" class="num-input"> -->
        <input type="tel" v-model="num" pattern="[0-9]*" class="num-input">
        <div class="num-confirm" @click="numConfirm">确认</div>
      </div>
    </div>
    <div class="del-icon" @click="closeHandle"><IDelTag></IDelTag></div>
  </van-popup>
</template>

<script>
import { IDelTag } from '@/components/ITag';

export default {
  name: 'numChange',

  data() {
    return {
      num: 1
    };
  },
  components: {
    IDelTag
  },
  methods: {
    closeHandle() {
      this.$emit('inputNumClose');
    },
    numConfirm() {
      this.$emit('numConfirm', this.num);
    }
  },
  props: {
    show: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    originNum: {
      type: Number,
      default: () => {
        return 1;
      }
    }
  },
  mounted() {
  },
  computed: {
    // compuNum() {

    // }
  },
  watch: {
    originNum(n) {
      this.num = n;
    }
  },
};
</script>

<style scoped lang="stylus">
.shop_car_container {
  background unset;
  .pop-wrap {
    background: #fff;
    overflow: hidden;
    border-radius: 20px;
    .num-title {
      font-size: 20px;
      font-weight: 500;
      padding: 20px 0;
      text-align: center;
    }
    .num-input {
      width: 80%;
      height: 38px;
      border: 1px solid #ddd;
      display: block;
      margin: 0 auto;
      text-align: center;
    }
    .num-confirm {
      width: 90%;
      margin: 20px auto;
      height: 38px;
      background: rgb(255, 95, 46);
      border-radius: 19px;
      color: #fff;
      text-align: center;
      line-height: 38px;
    }
  }

  .del-icon {
    margin: 20px auto 0 auto;
    text-align: center
    width: 30px;
    height: 30px;
    .del_container{
      width: 30px;
      height: 30px;
      background-size 30px 30px
    }
  }
}
</style>
